import { createContext, useContext, useEffect, useState } from "react";

import { getAuth, removeAuth, setAuth } from "../Utils/auth.utils";
import { getAuthMapping, removeAuthMapping, setAuthMapping } from "../Utils/authmapping.utils";

const AuthContext = createContext({
    auth: getAuth(),
    saveAuth: () => {},
    saveAuthMapping: () => {},
    currentUser: null,
    setCurrentUser: () => null,
    logout: () => {},
    updateUserAccount: () => {}
});

const useAuth = () => {
    return useContext(AuthContext)
}

const AuthProvider = ({children}) => {
    const [currentUser, setCurrentUser] = useState(getAuth());
    const [auth, setAuthContext] = useState(getAuth());
    const [authMapping, setAuthContextMapping] = useState(getAuthMapping());

    const saveAuth = (auth) => {
        setAuthContext(auth);
        if(auth) {
            setAuth(auth);
        } else {
            removeAuth();
        }
    }
    const saveAuthMapping = (auth) => {
        setAuthContextMapping(auth);
        if(auth) {
            setAuthMapping(auth);
        } else {
            removeAuthMapping();
        }
    }

    const clearCookies = () => {
        const cookies = document.cookie.split("; ");
        for (let cookie of cookies) {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        }
    }

    const logout = () => {
        saveAuth(null)
        saveAuthMapping(null)
        setCurrentUser(null)
        removeAuth();
        clearCookies();
      }

      const updateUserAccount = (userAccount) => {
        setAuthContext((prevAuth) => ({
            ...prevAuth,
            user_accounttype: userAccount 
        }));
        setAuth({
            ...auth,
            user_accounttype: userAccount
        });
    };


    const value = {auth,authMapping, saveAuth, saveAuthMapping,currentUser, setCurrentUser, logout , updateUserAccount};

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

const AuthInit= ({children}) => {
    const {auth, setCurrentUser, saveAuth,saveAuthMapping} = useAuth();

    useEffect(()=>{
        const date = new Date().getTime();

        if(auth && auth.expiresAt >= date) {
            setCurrentUser(auth.emailAddress);
        } else {
            setCurrentUser(null);
            saveAuth(null);
            saveAuthMapping(null)
        }

    },[auth])

    return <>{children}</>
}

export {AuthProvider, AuthInit, useAuth}